module.exports = __webpack_public_path__ + "img/logo.fe7bffd3.png";